export function getVariantId() {
  const variantElement = document.querySelector("#ryb-connect[data-variant]");
  if (!variantElement) {
    return "";
  }

  const dataVariant = variantElement?.getAttribute("data-variant");
  if (dataVariant?.toLowerCase() === "main") {
    return "";
  }

  return ryb_connect_classes_data.variants.find(
    (variant) => variant.name === dataVariant
  )?.id;
}
